import {Icon} from '#component/base';
import RectangleSkeleton from '#component/base/skeletons/RectangleSkeleton';

import * as css from './EmptyHistory.css';

export const EmptyCard = () => (
  <div className={css.rootCard}>
    <div className={css.rectanglesWrapper}>
      <div className={css.rectangle}>
        <RectangleSkeleton width={355} height={120} rx={0} ry={0} />
      </div>
      <div className={css.rectangle}>
        <RectangleSkeleton width={275} height={120} rx={0} ry={0} />
      </div>
    </div>

    <div className={css.lockWrapperComponent}>
      <div className={css.lockComponent}>
        <Icon name="Lock" color="dustyGray" size={74} weight="thin" />
      </div>
    </div>
  </div>
);
